import * as React from 'react';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { MuiMarkdown } from 'mui-markdown';

export default function Privacy() {
  return (
    <>
        <Box
          sx={{
            bgcolor: 'background.paper',
            pt: 10,
            pb: 6,
          }}
        >
          <Container maxWidth="lg">
            <Typography
              component="h1"
              variant="h2"
              color="text.primary"
              gutterBottom
              sx={{fontWeight:"bolder"}}
            >
             Aviso de privacidad
            </Typography>

            <MuiMarkdown>{`
**Fecha de entrada en vigor:** 2 Mayo 2025

En **CQURITY ACCESS**, nos comprometemos a proteger su privacidad. 
Esta Declaración de Privacidad explica cómo recopilamos, usamos, 
divulgamos y protegemos su información cuando visita nuestro sitio web y 
utiliza nuestro Sistema Web de Aparcamiento de Autos (el "Servicio"). 
Lea atentamente esta declaración. 
Si no está de acuerdo con los términos de esta declaración de privacidad, 
le rogamos que no utilice nuestro servicio.
<br>
<br>
#### 1. Información que recopilamos
<br>
Podemos recopilar los siguientes tipos de información:

**Información personal:**
- Nombre
- Correo electrónico
- Número de teléfono
- Datos del vehículo (p. ej., matrícula, modelo)
- Información de pago (si corresponde)

**Datos de uso:**
- Dirección IP
- Tipo de navegador
- Información del dispositivo
- Páginas visitadas
- Fecha y hora de las visitas

**Datos de ubicación:**
- GPS o ubicación aproximada, si activa los servicios de ubicación
<br>
<br>

#### 2. Cómo usamos su información
<br>
Utilizamos la información que recopilamos para diversos fines, entre ellos:

- Para proporcionar y gestionar reservas de aparcamiento
- Para mejorar la funcionalidad y el rendimiento de nuestro sistema
- Para procesar pagos (si corresponde)
- Para enviar mensajes de confirmación o avisos importantes
- Para mejorar la atención al cliente y responder a consultas
- Para cumplir con las obligaciones legales
<br>
<br>

#### 3. Compartir su información
<br>
No vendemos su información personal. Podemos compartir su información con:

- **Proveedores de servicios** (p. ej., procesadores de pagos, servicios de alojamiento) que colaboran en la prestación de nuestros servicios
- **Organismos reguladores o encargados de hacer cumplir la ley** si así lo exige la ley
- **Afiliados o socios**, con su consentimiento, para servicios conjuntos
<br>
<br>

#### 4. Seguridad de los datos
<br>
Implementamos las medidas técnicas y organizativas adecuadas para proteger su información personal del acceso, la divulgación, la alteración o la destrucción no autorizados.
<br>
<br>

#### 5. Sus derechos y opciones
<br>
Dependiendo de su ubicación, puede tener los siguientes derechos:

- Acceso a los datos personales que conservamos sobre usted
- Solicitar la corrección o eliminación de sus datos personales
- Oponerse o restringir determinados tratamientos
- Retirar el consentimiento, cuando el tratamiento se base en el consentimiento

Para ejercer estos derechos, póngase en contacto con nosotros en **[Insertar correo electrónico de contacto]**.
<br>
<br>
#### 6. Cookies y tecnologías de seguimiento
<br>
Podemos utilizar cookies y tecnologías similares para mejorar su experiencia, analizar el uso y personalizar el contenido. Puede gestionar las preferencias de cookies a través de la configuración de su navegador.
<br>
<br>
#### 7. Cambios a esta Declaración de Privacidad

Podemos actualizar esta Declaración de Privacidad ocasionalmente. Cualquier cambio se publicará en esta página con su fecha de entrada en vigor actualizada.
<br>
<br>
#### 8. Contáctenos
<br>
Si tiene alguna pregunta o inquietud sobre esta Declaración de Privacidad o nuestras prácticas de datos, <br>comuníquese con:
<br>
**CQURITY ACCESS** Dirección: Calle 22 NORTE #218, B,RESURGIMIENTO, 72370 PUEBLA, PUEBLA 
<br>
**Correo electrónico:** pagfe@cqurity.mx, cristian.serrano@cqurity.mx
<br>
**Teléfono:** 2211630363
            `}
                </MuiMarkdown>
          </Container>
          
        </Box>
      </>
  );
}